import { DEFAULT_CONFIG } from '../constants';

class GeminiApiService {
  constructor() {
    this.primaryUrl = DEFAULT_CONFIG.serverUrl;
  }

  async askAssistant(prompt) {
    try {
      const response = await fetch(this.primaryUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ prompt }),
      });

      if (!response.ok) {
        const errText = await response.text();
        let parsed;
        try {
          parsed = JSON.parse(errText);
        } catch (e) {
          parsed = { error: errText };
        }
        throw new Error(parsed.error || `Server responded with ${response.status}`);
      }

      const data = await response.json();
      return data.reply;
    } catch (err) {
      console.error('[GeminiService] Network or parsing error:', err);
      throw new Error(`Failed to contact AI backend at ${this.primaryUrl}. Check network or server status.`);
    }
  }
}

export const geminiApiService = new GeminiApiService();
